import productViewAvailabilityQuestionHtml from './productviewavailabilityquestion.component.html';
import './productviewavailabilityquestion.component.scss';

class ProductViewAvailabilityQuestionController {
    constructor($scope, $http, SnackbarService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.SnackbarService = SnackbarService;

        this.productName = null;
        this.attributeName = null;
        this.attributeValueName = null;
        this.loading = false;
        this.showAllErrors = false;

        this.data = {
            email: ''
        };

        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        this.dataValidations = {
            email: () => emailRegex.test(String(this.data.email).toLowerCase())
        };
    }

    isValid() {
        for (const validatorFnName in this.dataValidations) {
            if (!this.dataValidations[validatorFnName]()) return false;
        }

        return true;
    }

    $onInit() {
        this.productName = this.productName;
        this.attributeName = this.attributeName;
        this.attributeValueName = this.attributeValueName;

        this.data.productId = this.productId;
        this.data.variantId = this.variantId ? this.variantId : 0;
        this.data.attributeId = this.attributeId;
        this.data.attributeValueId = this.attributeValueId;
        this.data.attributeName = this.attributeName;
        this.data.attributeValueName = this.attributeValueName;
    }

    save() {
        this.showAllErrors = true;

        if (!this.isValid()) return;

        this.loading = true;

        this.$http.post(
            '/ajax/products/productAvailabilityQuestion',
            this.data
        ).then(
            (response) => {
                this.loading = false;

                this.$scope.$parent.$ctrl.close();

                this.SnackbarService.add(response.data.message.content, response.data.message.type, true, 3000);
            },
            (error) => {
                this.loading = false;

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);
            }
        );
    }

    close() {
        this.$scope.$parent.$ctrl.close();
    }
}

let productViewAvailabilityQuestionComponent = {
    bindings: {
        productId: '<',
        variantId: '<',
        productName: '@',
        attributeId: '<',
        attributeValueId: '<',
        attributeName: '@',
        attributeValueName: '@'
    },
    template: productViewAvailabilityQuestionHtml,
    controller: ProductViewAvailabilityQuestionController
}

export default productViewAvailabilityQuestionComponent;
